import { TestIssueService } from '@/api/testIssue';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { Button, Dialog, Modal, ModalRef } from 'alurkerja-ui';
import React, { useRef } from 'react';
import { FaTrash } from 'react-icons/fa';

type DeleteTestIssueProps = {
  id: string;
  onSuccess: () => void;
};

export const DeleteTestIssue: React.FC<DeleteTestIssueProps> = ({
  id,
  onSuccess,
}) => {
  const ref = useRef<ModalRef>(null);
  const { mutate: deleteMutate, isPending: isDeleteLoading } =
    TestIssueService.useDelete();
  const { mutate: archiveMutate, isPending: isArchiveLoading } =
    TestIssueService.useArchive();

  const deleteAction = (id: string) => {
    deleteMutate(id, {
      onSuccess: () => {
        Dialog.success({
          title: 'Success',
          description: 'Issue has been deleted',
          callback: () => {
            onSuccess();
            ref.current?.closeModal();
          },
        });
      },
      onError: () => {
        Dialog.error({
          title: 'Error',
          description: 'Failed to delete issue',
        });
      },
    });
  };

  const archiveAction = (id: string) => {
    archiveMutate(id, {
      onSuccess: () => {
        Dialog.success({
          title: 'Success',
          description: 'Issue has been archived',
          callback: () => {
            onSuccess();
            ref.current?.closeModal();
          },
        });
      },
      onError: () => {
        Dialog.error({
          title: 'Error',
          description: 'Failed to archive Issue',
        });
      },
    });
  };

  return (
    <Modal
      ref={ref}
      triggerButton={
        <Button
          className="bg-red-600"
        >
          <FaTrash />
        </Button>
      }
      title="Delete Issue"
    >
      {({ closeModal }) => {
        return (
          <div className="flex flex-col gap-4 p-4">
            <p className="text-gray-500">
              Are you sure you want to delete this issue? This action cannot be
              undone.
            </p>

            <div className="flex flex-row gap-2">
              <OutlineButton onClick={closeModal}>Cancel</OutlineButton>
              <Button
                type="button"
                color="red"
                onClick={() => deleteAction(id)}
                loading={isDeleteLoading}
              >
                Delete
              </Button>
              <Button
                type="button"
                onClick={() => archiveAction(id)}
                loading={isArchiveLoading}
              >
                Archive
              </Button>

              {/* </div> */}
            </div>
          </div>
        );
      }}
    </Modal>
  );
};
